import {
	type CURRENCYCODETYPE,
	type IBeneficiary,
	type ICurrencyDropDownItem,
	type IMeta,
	type ITransactionDetailsRow,
	type IUseFormStage,
	type IUseFormStageNavigator,
	type IUseWalletAddressProviderApi,
	type IWalletProps,
	type NetworkType,
	selectedBeneficiarySchema,
} from 'BreetHelpers';
import type { UseFormReturn } from 'react-hook-form';
import * as yup from 'yup';

export type FIATWITHDRAWREQUESTSTAGETYPE = 'withdraw-funds' | 'add-beneficiary' | 'withdraw-details' | 'manage-beneficiaries';

export const requestPaymentStageTitle: Record<FIATWITHDRAWREQUESTSTAGETYPE, string> = {
	'withdraw-funds': 'Withdraw',
	'add-beneficiary': 'Add Bank Account',
	'withdraw-details': 'Withdrawal Confirmation',
	'manage-beneficiaries': 'Manage Accounts',
};

export interface IFiatWithdrawRequestContext {
	userWalletProps: IWalletProps;
	meta?: IMeta;
	withdrawRequestHookForm: UseFormReturn<CreateWithdrawRequestFormSchemaType>;
	formStage: IUseFormStage<FIATWITHDRAWREQUESTSTAGETYPE>;
	beneficiaries: IBeneficiary[];
}

export const CreateWithdrawRequestFormSchema = yup.object({
	amount: yup.string().required('Amount details required'),
	selectedBeneficiary: selectedBeneficiarySchema,
	narration: yup.string().default(''),
});

export type CreateWithdrawRequestFormSchemaType = yup.InferType<typeof CreateWithdrawRequestFormSchema>;

export interface ITransactionDetails {
	content: ITransactionDetailsRow[];
	balance: string;
	withdrawalFee: string;
	narration: string;
	code: CURRENCYCODETYPE;
	totalDeducted: string;
	isInsufficientFunds: boolean;
	withdrawFunds: () => void;
}

export interface IWithdrawRequestContext {
	selectedWallet?: ICurrencyDropDownItem;
	selectWallet?: (wallet: ICurrencyDropDownItem) => void;
}

// weferwf

export type USDWITHDRAWREQUESTSTAGETYPE =
	| 'withdraw-funds'
	| 'add-wallet-address'
	| 'saved-wallet-address'
	| 'manage-wallet-address'
	| 'scan-wallet-address'
	| 'crypto-transaction-details';

export const requestPaymentUsdStageTitle: Record<USDWITHDRAWREQUESTSTAGETYPE, string> = {
	'withdraw-funds': 'Withdraw Stablecoin',
	'saved-wallet-address': 'Saved Address',
	'add-wallet-address': 'Add Wallet Address',
	'manage-wallet-address': 'Manage Address',
	'scan-wallet-address': 'Scan Address',
	'crypto-transaction-details': 'Withdraw Stablecoin Details',
};

export const tabs = ['Send Crypto'] as const;

export type TABTYPE = (typeof tabs)[number];

export interface IUsdWithdrawRequestContext extends IUseWalletAddressProviderApi {
	formStage: IUseFormStage<USDWITHDRAWREQUESTSTAGETYPE>;
}

export interface ISendCryptoAlternativeProps {
	isSavedWalletAddressesEmpty: boolean;
	navigator: IUseFormStageNavigator<USDWITHDRAWREQUESTSTAGETYPE>;
	handleScanAddress: () => void;
}

export interface INetworkProps {
	network: NetworkType;
	avatar: string;
}
